import { create } from 'zustand';

export type WorkflowStatus =
  | 'idle'
  | 'requesting'
  | 'completed'
  | 'errored'
  | 'timed-out';

export interface AIWorkflowJobResult<T> {
  jobId: string;
  result: null | T;
  error: null | string;
  location: string;
  streamLocation: string;
  runId: string | null;
}

export interface AIWorkflowState<T> {
  jobStarted: () => void;
  workflowResult: AIWorkflowJobResult<T> | undefined;
  setResults: (results: AIWorkflowJobResult<T>) => void;
  setHasTimedOut: () => void;
  setHasErrored: () => void;
  status: WorkflowStatus;
  reset: () => void;
}

export function createAiWorkflowStore<T>() {
  return create<AIWorkflowState<T>>((set) => ({
    jobStarted: () =>
      set(() => ({
        status: 'requesting',
        workflowResult: undefined,
      })),
    workflowResult: undefined,
    setResults: (result: AIWorkflowJobResult<T>) => {
      set(() => ({
        workflowResult: result,
        status: 'completed',
      }));
    },
    setHasTimedOut: () => {
      set(() => ({
        status: 'timed-out',
        workflowResult: undefined,
      }));
    },
    setHasErrored: () => {
      set(() => ({
        status: 'errored',
      }));
    },
    status: 'idle',
    reset: () => {
      set(() => ({
        status: 'idle',
        workflowResult: undefined,
      }));
    },
  }));
}
